import { ref } from 'vue'

export function useShoppingList() {
  const activeReplacementIndex = ref<number>()
  const closedGroups = ref<string[]>([])
  const expandedIngredientId = ref<number>()
  return { activeReplacementIndex, closedGroups, expandedIngredientId }
}
